import IframeContent from '../../../taskManagement/createLightbox/project/IframeContent'
import WelcomeScreenLightboxHeader from './WelcomeScreenLightboxHeader'
import WelcomeScreenLightboxFooter from './WelcomeScreenLightboxFooter'
import LightBox from '../../../components/LightBox'

export default class WelcomeScreenLightbox extends LightBox {

    constructor({
        onCloseCallback,
        iframeLoadCallback,
        frameName,
        loadExternalWelcomeScreen,
        showCloseButton = true,
        className = ''
    }) {
        super()

        this.callbacks = {
            onCloseCallback,
            iframeLoadCallback,
        }

        this.params = {
            frameName,
            loadExternalWelcomeScreen,
            showCloseButton,
            className,
        }
    }

    changeUrl(url) {
        this.content.setState({url})
    }

    changeSize(size) {
        this.content.setState({size})
        this.centrePopup()
    }

    lightBoxHideHandle() {}

    init() {
        const { loadExternalWelcomeScreen, showCloseButton } = this.params
        const header = new WelcomeScreenLightboxHeader({ loadExternalWelcomeScreen, showCloseButton })
        const footer = new WelcomeScreenLightboxFooter({ loadExternalWelcomeScreen })
        this.content = new IframeContent({
            iframeLoadCallback: this.callbacks.iframeLoadCallback,
            frameName: this.params.frameName,
        })

        super.init(
            {
                id: 'welcomeScreenLightbox',
                header,
                content: this.content,
                footer,
                classNames: 'externalContentLightbox ' + this.params.className,
                correctionOffset: 60,
                moireDivId: 'blueMoireDiv',
                cancelCallback: this.callbacks.onCloseCallback,
            })
        return this
    }
}


// WEBPACK FOOTER //
// ./web/js/support/welcomeScreen/components/WelcomeScreenLightbox.js